import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import ActionButtonStyle from 'txp-data/lib/schema/viewSchema/ActionButtonStyle';

export default function getButtonStyle(style: ActionButtonStyle): IButtonStyles {
    if (style) {
        const buttonStyle: IButtonStyles =
            style.darkerColor && style.lighterColor && style.lightColor
                ? {
                      rootHovered: {
                          color: style.darkerColor,
                          backgroundColor: style.lighterColor,
                      },
                      rootPressed: {
                          color: style.darkerColor,
                          backgroundColor: style.lightColor,
                      },
                      root: {
                          backgroundColor: 'transparent',
                          borderRadius: '2px',
                          color: style.darkColor,
                          padding: '6px 20px 6px 8px',
                      },
                  }
                : null;
        return buttonStyle;
    }
    return null;
}
